'use client';
import { ReactNode, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import localFont from 'next/font/local';

const fixelDisplayFont = localFont({
  src: [
    {
      path: '../../styles/fonts/FixelDisplay-Regular.woff2',
      weight: '400',
    },
    {
      path: '../../styles/fonts/FixelDisplay-SemiBold.woff2',
      weight: '600',
    },
    {
      path: '../../styles/fonts/FixelDisplay-Bold.woff2',
      weight: '700',
    },
  ],
  variable: '--font-fixel',
  display: 'swap',
});

export default function PageWrapper({ children }: { children: ReactNode }) {
  const [circleColor, setCircleColor] = useState('blur-gradient-green');
  const pathname = usePathname();

  useEffect(() => {
    if (pathname?.includes('/school/')) {
      setCircleColor('blur-gradient-violet');
    } else if (pathname?.includes('/university/')) {
      setCircleColor('blur-gradient-blue');
    } else {
      setCircleColor('blur-gradient-green');
    }
  }, [pathname]);

  useEffect(() => {
    document.body.classList.add('scroll-smooth');
    document.body.classList.add(fixelDisplayFont.className);
    return () => {
      document.body.classList.remove(fixelDisplayFont.className);
    };
  }, []);
  return (
    <>
      <div className="h-full w-full relative overflow-hidden">
        <div className="h-full w-full overflow-hidden">
          <div className={`${circleColor} top-0 -right-[60%] -z-50`}></div>
          <div className={`${circleColor} -left-[55%] top-0 -z-50`}></div>
          <div className={`${circleColor} -right-[45%] translate-y-[90%] -z-50`}></div>
          <div className={`${circleColor} top-[30%] -left-[70%] translate-x-[80%] -z-50`}></div>
          <div
            className={`${circleColor} -bottom-44 translate-x-[20%] -translate-y-[50%] -z-50`}
          ></div>
        </div>
        <main className="relative">{children}</main>
        {/* <Banner /> */}
      </div>
    </>
  );
}
